import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: 'settings',
    initialState: {
        unitMeasures: {},
    },
    reducers: {
        setUnitMeasures(state, action) {
            state.unitMeasures = action.payload
        },
    }
})

export default slice.reducer

export const {
    setUnitMeasures,
} = slice.actions